// eventBus.ts
interface EventBus {
    listeners: { [key: string]: ((data: any) => void)[] };
    on(eventName: string, callback: (data: any) => void): void;
    emit(eventName: string, data: any): void;
    off(eventName: string, callback: (data: any) => void): void;
  }
  
  const eventBus: EventBus = {
    listeners: {},
  
    on(eventName: string, callback: (data: any) => void) {
      if (!this.listeners[eventName]) {
        this.listeners[eventName] = [];
      }
      this.listeners[eventName].push(callback);
    },
  
    emit(eventName: string, data: any) {
      if (this.listeners[eventName]) {
        this.listeners[eventName].forEach((callback: (data: any) => void) => callback(data));
      }
    },
  
    off(eventName: string, callback: (data: any) => void) {
      if (this.listeners[eventName]) {
        this.listeners[eventName] = this.listeners[eventName].filter((cb: (data: any) => void) => cb !== callback);
      }
    },
  };
  
  export default eventBus;